module.exports = __webpack_public_path__ + "img/adjust_home_icon2.a9eab128.png";